export const FETCH_CREDENTIALS = 'fetchCredentials';
export const EDIT_CREDENTIAL = 'editCredential';
export const SAVE_CREDENTIAL = 'saveCredential';
export const ADD_CREDENTIAL = 'addCredential';
export const UPDATE_CREDENTIAL = 'updateCredential';
export const RESET_STATE = 'resetState';
